import { getStore } from "../store/store";
import { mutatorAction } from "satcheljs";

const markImportAsLoadedMutator: (ids: string[]) => void = mutatorAction("MARK_IMPORT_AS_LOADED", function markImportAsLoaded(ids: string[]): void {
    for (const id of ids) {
        getStore().loadedImports.set(id, true);
    }
});
export default markImportAsLoadedMutator;
